export default __webpack_public_path__ + "static/media/header.d6c8ede1.svg";